// src/components/WhatsAppChoiceButton.js
import React, { useState } from 'react';

const WhatsAppChoiceButton = ({ loading, isDirect = false }) => {
  const [showOptions, setShowOptions] = useState(false);

  const ADMIN_BANDA = "6281264427001";
  const ADMIN_JAKARTA = "6289669780850";

  // Format Pesan Khusus Event Detail (Direct)
  // src/components/WhatsAppChoiceButton.js

const DIRECT_MESSAGE = "Halo%20NEJTRIP!%20Saya%20siap%20bergabung%20di%20Open%20Trip%20Banda%20Neira%20Via%20Pelni%202026%0A%0AData%20saya%3A%0ANama%3A%20%5BNama%5D%0ADomisili%3A%20%5BKota%5D%0ANo.%20HP%3A%20%5BNomor%5D%0A%0ASaya%20pilih%20paket%20Via%20Pelni%20(Backpacker)%20bersama%20Nejtrip.%0AMohon%20info%20slot%20yang%20tersedia%20dan%20langkah%20bookingnya%20ya.";

  // Format Pesan Umum (Beranda)
  const GENERAL_MESSAGE = "Halo%20Admin%2C%20saya%20tertarik%20trip%20ke%20Banda%20Neira%20dengan%20paket%203D2N%20%2F%204D3N%20%2F%20Privat%20%2F%20Via%20Pelni.%20Mohon%20info%20lebih%20lanjut%20dan%20slot%20yang%20tersedia.";

  const handleWaTracking = (label) => {
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: `WA Button - ${label}`,
        value: 2700000,
        currency: 'IDR'
      });
    }
  };

  if (loading) return null;

  // --- KONDISI 1: JIKA IS_DIRECT (Hanya di Page Event / Mepo) ---
  if (isDirect) {
    return (
      <div className="whatsapp-container">
        <a 
          href={`https://wa.me/${ADMIN_JAKARTA}?text=${DIRECT_MESSAGE}`} 
          target="_blank" 
          rel="noopener noreferrer"
          onClick={() => handleWaTracking('Direct Event Detail')}
          className="whatsapp-toggle-button"
        >
          <img src="https://img.icons8.com/color/48/000000/whatsapp.png" alt="WA Direct" className="whatsapp-icon-toggle" />
        </a>
      </div>
    );
  }

  // --- KONDISI 2: JIKA BIASA (Beranda / Home) ---
  return (
    <div className="whatsapp-container">
      {showOptions && (
        <div className="whatsapp-options-wrapper">
          <a href={`https://wa.me/${ADMIN_BANDA}?text=${GENERAL_MESSAGE}`} 
             target="_blank" rel="noopener noreferrer"
             className="whatsapp-option-link" 
             onClick={() => handleWaTracking('Admin Banda')}>
            <img src="https://img.icons8.com/color/30/000000/whatsapp.png" alt="WA" />
            <span className="whatsapp-option-text">Admin Banda</span>
          </a>

          <a href={`https://wa.me/${ADMIN_JAKARTA}?text=${GENERAL_MESSAGE}`} 
             target="_blank" rel="noopener noreferrer"
             className="whatsapp-option-link" 
             onClick={() => handleWaTracking('Admin Jakarta')}>
            <img src="https://img.icons8.com/color/30/000000/whatsapp.png" alt="WA" />
            <span className="whatsapp-option-text">Admin Jakarta</span>
          </a>
        </div>
      )}
      
      <button onClick={() => setShowOptions(!showOptions)} className="whatsapp-toggle-button">
        <img 
          src={showOptions 
               ? "https://img.icons8.com/ios-filled/50/ffffff/delete-sign--v1.png" 
               : "https://img.icons8.com/color/48/000000/whatsapp.png" 
          } 
          alt="Toggle" 
          className="whatsapp-icon-toggle" 
        />
      </button>
    </div>
  );
};

export default WhatsAppChoiceButton;